// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/create_experiment_response.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ExperimentData } from "./experiment_data_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_experiment_data } from "./experiment_data_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/create_experiment_response.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_create_experiment_response: GenFile = /*@__PURE__*/
  fileDesc("CkhxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvY3JlYXRlX2V4cGVyaW1lbnRfcmVzcG9uc2UucHJvdG8SJ3F1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MSJvChhDcmVhdGVFeHBlcmltZW50UmVzcG9uc2USSgoEZGF0YRgBIAEoCzI3LnF1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MS5FeHBlcmltZW50RGF0YUgAiAEBQgcKBV9kYXRhYgZwcm90bzM", [file_quanterix_simoa_one_analysis_app_api_v1_experiment_data]);

/**
 * Rpc response containing initial data for a newly-created experiment
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.CreateExperimentResponse
 */
export type CreateExperimentResponse = Message<"quanterix.simoa_one.analysis_app_api.v1.CreateExperimentResponse"> & {
  /**
   * Initialized data for the new experiment
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.ExperimentData data = 1;
   */
  data?: ExperimentData;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.CreateExperimentResponse.
 * Use `create(CreateExperimentResponseSchema)` to create a new message.
 */
export const CreateExperimentResponseSchema: GenMessage<CreateExperimentResponse> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_create_experiment_response, 0);

